import { combineReducers } from 'redux';
import { silos } from './silos';

// Export all reducers in combined reducer object
export default combineReducers({
  silos,
});
